module.exports = "/images/CMJ.png?19109588b0e3de04531d7e11d14d5b64";